<template>
  <div class="content-form__switch-field">
    <div class="content-form__switcher-wrap">
      <div class="content-form__switcher-label">
        {{ $t('pageManageSheet.settings.enableSearch') }}
        <UiHelper
          class="va-bottom ml-2"
          popoverFeature="search"
          showCloseBtn
          :videoData="{
            src: '/video/helper-popup/search.mp4',
            label: 'Learn how to set up search',
            btns: [
              {
                label: 'Learn more',
                to: 'https://help.spreadsimple.com/en/article/how-to-set-up-search-1h1yu04',
                externalResource: true,
                color: 'secondary-blue',
                event: {
                  type: 'goToHelp'
                }
              },
              {
                label: 'Watch video',
                to: { name: 'help-video', query: { show: 'search' }},
                event: {
                  type: 'goToVideo'
                }
              }
            ]
          }"
        />
      </div>
      <label
        :class="{ 'selected': search.enabled }"
        class="switcher"
      >
        <input
          v-model="search.enabled"
          class="switcher__input"
          type="checkbox"
          value="tiles"
          @change="$trackFeature('content', 'search', search.enabled)"
        >
        <span class="switcher__indicator"></span>
      </label>
    </div>
    <div v-if="search.enabled" class="content-form__switch-hidden-field aside-select paddingless">
      <div class="content-form__highlighted">
        <div class="sorting-constructor__item">
          <FormField label="Search placeholder" class="side-form__item aside-input">
            <v-text-field
              v-model.trim="search.placeholder"
              :placeholder="msg.searchPlaceholder"
            />
          </FormField>
        </div>
        <h6 class="aside-field-label">Search by columns</h6>
        <v-select
          :value="search.searchByColumns"
          :items="cols"
          item-text="label"
          item-value="id"
          attach
          menu-props="offsetY"
          chips
          deletable-chips
          multiple
          placeholder="Choose options"
          append-icon="keyboard_arrow_down"
          @change="updateSearchableColumns"
        >
          <template slot="selection" slot-scope="data">
            <DraggableChip
              :id="data.index"
              :value="search.searchByColumns"
              @input="updateSearchableColumns"
            >
              {{ data.item.label }}
            </DraggableChip>
          </template>
        </v-select>

        <div class="content-form__switcher-wrap" style="margin-top: 16px;">
          <div class="content-form__switcher-label">
            {{ $t('pageManageSheet.settings.enableIntroSearch') }}
          </div>
          <label
            :class="{ 'selected': search.introSearch.enabled }"
            class="switcher"
          >
            <input
              v-model="search.introSearch.enabled"
              class="switcher__input"
              type="checkbox"
              @change="$trackFeature('content', 'introSearch', search.introSearch.enabled)"
            >
            <span class="switcher__indicator"></span>
          </label>
        </div>
        <template v-if="search.introSearch.enabled">
          <div class="sorting-constructor__item">
            <FormField label="Empty state text" class="side-form__item aside-input">
              <v-text-field
                v-model.trim="search.introSearch.emptyStateText"
                placeholder="Nothing found"
              />
            </FormField>
          </div>
          <div class="sorting-constructor__item">
            <FormField label="Results limit" class="side-form__item aside-input">
              <v-text-field
                v-model.number="search.introSearch.resultsLimit"
                type="number"
                min="5"
                max="10"
                @change="clampResultsLimit"
              />
            </FormField>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import FormField from '@/components/form-field'
import UiHelper from '@/components/ui-helper'
import DraggableChip from '@/components/draggable-chip/DraggableChip.vue'
export default {
  name: 'SearchConstructor',
  components: {
    DraggableChip,
    FormField,
    UiHelper
  },
  props: {
    cols: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    msg: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      search: {}
    }
  },
  watch: {
    search: {
      deep: true,
      handler: function (val) {
        if (!val.searchByColumns.length) {
          this.search.enabled = false
          this.search.searchByColumns = this.cols.map(col => col.id)
        }
        if (!this.search.enabled && this.search.introSearch && this.search.introSearch.enabled) {
          this.search.introSearch.enabled = false
        }
        this.clampResultsLimit()
        this.$emit('input', val)
      }
    }
  },
  methods: {
    updateSearchableColumns (val) {
      this.search.searchByColumns = val
    },
    clampResultsLimit () {
      if (!this.search.introSearch) return
      let limit = Number(this.search.introSearch.resultsLimit)
      if (!Number.isFinite(limit)) limit = 8
      if (limit < 5) limit = 5
      if (limit > 10) limit = 10
      if (this.search.introSearch.resultsLimit !== limit) {
        this.search.introSearch.resultsLimit = limit
      }
    }
  },
  created () {
    this.search = JSON.parse(JSON.stringify(this.value))
    if (!this.search.searchByColumns.length) {
      this.search.searchByColumns = this.cols.map(col => col.id)
    }
    if (!this.search.introSearch) {
      this.search.introSearch = {
        enabled: false,
        emptyStateText: '',
        resultsLimit: 8
      }
    }
    this.clampResultsLimit()
  }
}
</script>
